module.exports = __webpack_public_path__ + "static/media/placeholder.7b56b11c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/placeholder.jpg
// module id = 298
// module chunks = 0